export function clickWithFocus(fn) {
    return {
        tabIndex: 0,
        onClick: fn,
        onKeyDown: (e) => {
            if (e.key === 'Enter') {
                fn(e);
            }
        },
    };
}
